export default {
  namespaced: true,
  operational_procedure: {
    title: "Procedimiento Operativo",
    simulacrums_title: "Procedimiento Operativo",
    new: "Nuevo Procedimiento Operativo",
    reference_number: "Número de referencia",
    select_form: "Seleccionar formulario(s)",
    select_form_place_holder: "Selecciona un formulario",
    selected_form: "Formulario seleccionado",
    answer_form: "Iniciar formulario",
    confirm_delete: "¿Estás seguro de que deseas eliminar este simulacro?",
    no_records: "No se encontraron procedimientos operativos",
    reassign: "Reasignar",
    template: {
      title: "Plantillas de formulario",
    },
    confirm_cancel: "¿Estás seguro de que deseas cancelar este procedimiento operativo?",
    canceled: "Procedimiento operativo cancelado",
    reassigned: "Reasignado",
  },
  operational_procedure_exercise: {
    title: "Ejercicio Operativo",
    new: "Nuevo Ejercicio Operativo",
    template: {
      title: "Plantillas de formulario",
    },
  },
};
